import React, {Fragment, useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Form,Button,Spinner,} from 'react-bootstrap';
import axios from 'axios';
import Recepisse from '../../components/RecepisseDepot/index'
import Input from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import { InputOption } from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
import Update from '../Update/index';
import { useNavigate, useLocation } from 'react-router-dom';
import './recrutement.css';
import Env from '../../hooks/Env';
import PayUniforme from '../PayUniforme/Pay';
const renderTooltip = (props) => (
    <Tooltip id="button-tooltip"  {...props}>
      Ajouter un nouveau fichier
    </Tooltip>
  );
  const IconForFile = (props) => {
    return (
        <>
        <OverlayTrigger
            placement="right"
            delay={{ show: 100, hide: 400 }}
            overlay={renderTooltip}
            >
            <FontAwesomeIcon onClick={() => {props.toggleInputVisibility(props.name)}} icon={faFile} className='btn btn-primary mr-2' />
        </OverlayTrigger>
        </>
    )
  }
const Depot = ({props}) => {
    const API_URL = Env().API_URL ;
    const ANNEE_UNIVERSITE = Env().ANNEE_UNIVERSITE ;
    const [InputVisible, SetInputVisible] = useState({
        'communication5':false,
        'justificatif':false,
        'diplome':false,
        'publication2':false,
        'publication3':false,
        'publication4':false,
        'publication5':false,
        'publication6':false,
        'publication7':false,
        'publication8':false,
        'publication9':false,
        // 'publication10':false,
        'communication2':false,
        'communication3':false,
        'communication4':false,
        'justificatif2':false,
        'justificatif1':false,
        'justificatif3':false,
        'justificatif4':false,
        'justificatif5':false,
        'justificatif6':false,
        'justificatif7':false,
        'justificatif8':false,
        'diplome2':false,
        'diplome3':false,
        'diplome4':false,
        'diplome5':false,
        'diplome6':false,
    })
    const toggleInputVisibility = (state) => {
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
    }
    
    const removeFile = (fieldName,state) => {
        console.log("Au moment ",selectedFiles.publication7)
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
        // Créez une copie de l'état actuel
        const updatedFiles = { ...selectedFiles };
      
        // Supprimez l'élément spécifique
        updatedFiles[fieldName] = null;
      
        // Mettez à jour l'état avec la nouvelle copie
        setSelectedFiles(updatedFiles);
        console.log("Aprés mise à jour ",selectedFiles.publication7)
      };
    const [dataForm, setDataForm] = useState('');
    const [nationalities, setNationalities] = useState([]);
    const [step, setStep] = useState(1);
    const [update,setUpdate] = useState(false)
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const [message, setMessage] = useState('')
    const [typefille, setTypeFile] = useState(false)
    const[ messageAlerte, setMessageAlerte] = useState('')
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 * 2; //1Mo
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "cv":true,
        "copie_carte_id" : true,
        "demande" : true,
        "lettre_motivation" : true,
        "copie_diplome" : true,
        "recommandation1" : true,
        "recommandation2" : true,
        "resume_these" : true,
        "publication_scientifique" : true,
        "attestation_travail" : true,
        "justificatif1" : true,
        "justificatif2" : true,
        "justificatif3" : true,
        "justificatif4" : true,
        "justificatif5" : true,
        "justificatif6" : true,
        "communication" : true,
        "diplome2" : true,
        "diplome3" : true,
        "diplome4" : true,
        "diplome5" : true,
        "diplome6" : true,
        "justificatif7" : true,
        "justificatif8" : true,
        "communication2" : true,
        "communication3" : true,
        "communication4" : true,
        "communication5" : true,
        "publication2" : true,
        "publication3" : true,
        "publication4" : true,
        "publication5" : true,
        "publication6" : true,
        "publication7" : true,
        "publication8" : true,
        "publication9" : true,
        // "publication10" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "cv":false,
        "copie_carte_id" : false,
        "demande" : false,
        "lettre_motivation" : false,
        "copie_diplome" : false,
        "recommandation1" : false,
        "recommandation2" : false,
        "resume_these" : false,
        "publication_scientifique" : false,
        "attestation_travail" : false,
        "justificatif1" : false,
        "justificatif2" : false,
        "justificatif3" : false,
        "justificatif4" : false,
        "justificatif5" : false,
        "justificatif6" : false,
        "communication" : false,
        "diplome2" : false,
        "diplome3" : false,
        "diplome4" : false,
        "diplome5" : false,
        "diplome6" : false,
        "justificatif7" : false,
        "justificatif8" : false,
        "communication2" : false,
        "communication3" : false,
        "communication4" : false,
        "communication5" : false,
        "publication2" : false,
        "publication3" : false,
        "publication4" : false,
        "publication5" : false,
        "publication6" : false,
        "publication7" : false,
        "publication8" : false,
        "publication9" : false,
        // "publication10" : false,
    });
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        // console.log(selectedFiles.publication7)
        var file = event.target.files[0];
            const elements = document.getElementsByName(key)
            if (file?.size < maxFileSize){
                setTypeFile(false)
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var i = 0; i < elements.length; i++) {
                    var element1 = elements[i];
                    // console.log(element)
                    // Faites quelque chose avec chaque élément, par exemple :
                    element1.style.border = ""; // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }
            } else {
                setSelectedFiles((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: false
                }));
                for (var j = 0; j < elements.length; j++) {
                    var element = elements[j];
                    
                    element.style.border = "2px solid #BC0C0C";
                    element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                    // ... autres opérations sur l'élément
                }

            }
    };
    function handleChange (e) {
        const name= e.target.name;
        // handle checkbox groups for multi modules
        if (e.target.type === 'checkbox' && e.target.name === 'ecole_postulee') {
            const val = e.target.value;
            const checked = e.target.checked;
            setDataForm(prev => {
                const prevArr = Array.isArray(prev?.ecole_postulee) ? prev.ecole_postulee : [];
                if (checked) {
                    return { ...prev, ecole_postulee: [...prevArr, val] };
                } else {
                    return { ...prev, ecole_postulee: prevArr.filter(v => v !== val) };
                }
            });
            return;
        }
        let value;
        // handle multiple selects (kept for other possible multiple selects)
        if (e.target.multiple) {
            const selected = [];
            for (let i = 0; i < e.target.options.length; i++) {
                const opt = e.target.options[i];
                if (opt.selected) selected.push(opt.value);
            }
            value = selected;
        } else {
            value = e.target.value;
        }
        // console.log(value,name)
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // console.log(value,name)
    }
    // If redirected after payment, auto-fill email and advance step
    const { search } = useLocation();
    useEffect(() => {
        try {
            const params = new URLSearchParams(search || window.location.search);
            const email = params.get('email');
            const paid = params.get('paid');
            if (email && paid === 'true') {
                setDataForm(prev => ({ ...(typeof prev === 'object' ? prev : {}), email }));
                setStep(2);
            }
        } catch (e) {
            console.error('Error parsing payment redirect params', e);
        }
    }, [search]);
    const handleNextStep = async () => {
        if (step === 1) {
            if (!dataForm.email || !dataForm.fonction) {
                setMessageAlerte('Veuillez remplir tous les champs obligatoires');
                setShow(true);
                return;
            }
                // try {
                //     const email = encodeURIComponent(dataForm.email);
                //     const url = `${API_URL}/paiement/confirmed/cepec/${email}/${ANNEE_UNIVERSITE}`;
                //     const response = await axios.get(url);
                    
                //     if (response?.data?.detail) {
                //         setMessageAlerte(response.data.detail);
                //     } else {
                //         setStep(step + 1)
                //     }
                // } catch (error) {
                //     console.error('Error checking payment confirmation:', error);
                //     setMessageAlerte('Erreur lors de la vérification du paiement');
                //     setShow(true);
                // }
                setStep(step + 1)
        } else if (step === 2) {
            // console.log(dataForm.type_poste,dataForm.poste,dataForm.ecole_postulee,dataForm.annee_experience,dataForm.pays,dataForm.diplome)
            if (dataForm.type_poste === 'PATS') {
                if (dataForm.type_poste && dataForm.poste && dataForm.ecole_postulee && dataForm.annee_experience && dataForm.pays && dataForm.diplome) {
                    // when PATS, require mandatory modules
                    if (dataForm.type_poste === 'PATS') {
                        const selected = Array.isArray(dataForm.ecole_postulee) ? dataForm.ecole_postulee : [dataForm.ecole_postulee];
                        const required = [
                            "Leadership et coaching",
                            "Productivité augmentée avec le No-code et l'IA générative"
                        ];
                        const hasRequired = required.every(r => selected.includes(r));
                        if (!hasRequired) {
                            alert('Les modules "Leadership et coaching" et "Productivité" sont obligatoires');
                            setErrors(true);
                            setMessageAlerte('Les modules "Leadership et coaching" et "Productivité" sont obligatoires');
                            return;
                        }
                    }
                    setErrors(false);
                    setStep(step + 1);
                   } else {
                        setErrors(true);
                }   
            } else {
                if (dataForm.poste==="Executive Coaching") {
                    console.log(dataForm.poste,dataForm.annee_experience)
                    dataForm.annee_experience = 1;
                }
                if (dataForm.type_poste && dataForm.poste && dataForm.annee_experience && dataForm.pays && dataForm.diplome) {
                    setErrors(false);
                    setStep(step + 1);
                } else {
                    setErrors(true);
                }
            }
            
        }
    };
  
    const handlePreviousStep = () => {
      setStep(step - 1);
    };
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            const nameFiles = ["cv","copie_carte_id","demande","lettre_motivation","copie_diplome","communication","recommandation1","recommandation2","resume_these",
            "publication_scientifique","attestation_travail","justificatif1","justificatif2","justificatif3","justificatif4","justificatif5","justificatif6",
            "diplome2","diplome3","diplome4","diplome5","diplome6","justificatif7","justificatif8","communication2","communication3","communication4",
            "communication5","publication2","publication3","publication4","publication5","publication6","publication7","publication8","publication9"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                }
            }
            for (let key in dataForm) {
                // console.log(dataForm[key])
                if (dataForm.hasOwnProperty(key)) {
                      if( dataForm[key] !== null) {
                        formData.append(key ,dataForm[key])
                      }
              }
            }
            var showALerte = nameFiles.some(field => selectedFiles[field] === false);
            if (!valid.isValidPhoneNumber) {
                setMessageAlerte('Incorrect')
                setShow(true);
            
            }
            else if (showALerte) {
                 setShow(true);
                //  setOk(false)
            }
            else if (typefille) {
                alert('format de fichier incoorecte !')
            }
            else {
                setComplete(true)
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    `${API_URL}/recrutement/`,
                    formData,
                    {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
            // console.log(response)
            if (response.status === 200) {
                if (response.data.detail) {
                    setSubmitted(false);
                    setDeppotSuccess2(true)
                } else {
                    setSubmitted(false);
                    const dataPersonDepot = response?.data?.data;
                    setData(dataPersonDepot);
                    setDeppotSuccess(true);
                }
            } else {
                console.error('Error uploading files');
                console.log("Détail de la réponse ",response.status)
            }
        }
    } catch (error) {
        setSubmitted(false);
       console.error('Error', error);
    }
};
    const calculateProgress = () => {
        // Calculez le pourcentage de progression en fonction du numéro d'étape
        return (step / 3) * 100; // Supposons que vous ayez 3 étapes au total
      };
    function handleUpdate () {
        update ? setUpdate(false) : setUpdate(true)
        
    }
    const [gotoPayment, setGotoPayment] = useState(false);
    const [infosPayment, setInfosPayment] = useState(() => {
                return {
                    campagne: 'cepec',
                    email: data?.email || '',
                    annee_universitaire: data?.annee_universitaire || ''
                };
        });
    const fairePayment = () => {
        // ensure infosPayment contains a valid email (prefer saved data, fallback to current form)
        const email = data?.email || dataForm?.email || '';
        setInfosPayment({ campagne: 'cepec', email, annee_universitaire: ANNEE_UNIVERSITE });
        setGotoPayment(true);
    }
    return (
        <>
            {gotoPayment ? (
                <PayUniforme infos={infosPayment} />
            ) : (
                <>
                    <Alert show={show} handleClose={handleClose} />
                    {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
                    {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
                    {update ? <Update /> : null}
                    <div>
                            <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
                                    <Button variant='success' className=' p-2' onClick={handleUpdate}>Modifier son dossier </Button>
                            </div>
                    </div>
                        <div className='container mb-2 ' id='mainDepot'>
        {/* {step 1 } */}
        <div className='row'>
            <div className="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${calculateProgress()}%` }} ></div>
        </div>
                {!gotoPayment && (
                    <div id='nameModule' className=''>
                                        <p> {step===1 ? 'Informations personnelles' : 'Informations Complémentaires' }</p>
                </div>
                )}
            <div id='form' className={`step step-${step}`}>
            <Form onSubmit={handleSubmit}>
            <div>
                {step === 1 && !gotoPayment && (
                    <div id="step1" className='mb-3'>
                        <Input type='email' focus={true} value={dataForm.email || ''} placeholder='uam@uam.edu.sn' label="Email" name='email' onChange={handleChange} />
                        <Form.Group className='mt-3'>
                            <Form.Label className='fw-medium'>Moyen de paiement <span style={{color:'red'}}>*</span></Form.Label>
                            <Form.Select name="fonction" value={dataForm.fonction || ''} onChange={handleChange} required>
                                <option value='' disabled hidden>Choisir le moyen de paiement</option>
                                <option value='cash'>Cash</option>
                                <option value='tranches'>Par tranches</option>
                                <option value='autres'>Autres</option>
                            </Form.Select>
                        </Form.Group>
                        {!valid.isValidPhoneNumber ? <span style={{color:'red'}}>{messageAlerte} </span>: null}
                        {messageAlerte ==="Votre Paiement n'a pas étè enregisté" ?
                            <Button variant='warning' className='mt-2 mb-2' onClick={fairePayment}>Faire le paiement</Button>
                         : null}
                    </div>
                )}
                {step === 2 && (
                <div className='mb-3'>
                <Form.Group>
                            <div className='d-inline'>
                                <Form.Check
                                inline
                                        type="radio"
                                        label="Monsieur"
                                        value='Monsieur'
                                        required
                                        checked = {dataForm.civilite === 'Monsieur'}
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='d-inline'>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Madame"
                                        value='Madame'
                                        checked = {dataForm.civilite === 'Madame'}
                                        required
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                            </Form.Group>
                            <div className='row' id='test'>
                            <Input className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                            <Input className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange}/>
                            </div>
                            <div className='row'>
                                <Input className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date de Naissance" name='date_naissance' onChange={handleChange} />
                                <Input className="col-md-6 col-sm-12" value={dataForm.lieu_naissance || ''} type='text' label="Lieu de naissance" name='lieu_naissance' onChange={handleChange} />
                            </div> <InputT type='number' value={dataForm.telephone || ''} label="Téléphone"  name='telephone' onChange={handleChange} />
                            <Input type='text' value={dataForm.address || ''} label="Adresse" name='address' onChange={handleChange} />
                <Form.Group id='serie'>
                    <Form.Label className='fw-medium'>Personnel <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='type_poste' required value={dataForm.type_poste} onChange={handleChange}>
                        <option key='' value="" >--- Selectionner ---</option>
                        <option key='pats' value="PATS">Formation</option>
                    </Form.Select>
                </Form.Group>
                {dataForm.type_poste === 'PATS' ?
                     <Form.Group id=''>
                     <Form.Label className='fw-medium'>Modules Certifiants<span style={{color:'red'}}>*</span></Form.Label>
                    <div className="mb-2">
                        {[
                            'Productivité augmentée avec le No-code et l\'IA générative',
                            'Stratégies de communication et marketing digital',
                            'Dynamique d\'intelligence collective et facilitation',
                            'Synergies collaboratives et culture du travail en équipe',
                            'Entreprendre avec impact : de l\'idée à l\'action',
                            'Leadership et coaching'
                        ].map((m) => (
                            <Form.Check
                                key={m}
                                type="checkbox"
                                id={`module-${m}`}
                                label={m}
                                name="ecole_postulee"
                                value={m}
                                checked={Array.isArray(dataForm.ecole_postulee) && dataForm.ecole_postulee.includes(m)}
                                onChange={handleChange}
                                className="mb-1"
                            />
                        ))}
                    </div>
                 </Form.Group>
                : null} 
                <Form.Group id='ecole'>
                    <Form.Label className='fw-medium'>Type de Formation <span style={{color:'red'}}>*</span> </Form.Label>
                    <Form.Select name='poste' required value={dataForm.poste}  className='mb-2'  onChange={handleChange}>
                        <option value="" >--- Selectionner ---</option>
                        {dataForm.type_poste ? 
                        <>
                            {(dataForm.type_poste !== 'PATS' ) ?
                            <>
                                {dataForm.ecole_postulee ==='SEG' ? 
                                <>
                                    <InputOption label="Enseignant Chercheur en Gestion" />
                                    <InputOption label="Enseignant Chercheur en Mathématiques" />
                                </> : null}
                                {dataForm.ecole_postulee === 'STA' ? 
                                        <Fragment>
                                            <InputOption label="Enseignant Chercheur en Génie Civil " />
                                            {/* <InputOption label="Enseignant Chercheur en Ecologie Marine" /> */}
                                        </Fragment> 
                                : null}
                                {dataForm.ecole_postulee === 'TECNA' ? 
                                        <Fragment>
                                            <InputOption label="Enseignant Chercheur en Littérature Française du XVI ème Siècle" />
                                            <InputOption label="Enseignant Chercheur en Sociolinguistique" />
                                            <InputOption label="Enseignant Chercheur en Communication Digitale" />
                                            <InputOption label="Enseignant Chercheur en Sciences de gestion" />
                                        </Fragment> 
                                : null}
                                {dataForm.ecole_postulee === 'polytech' ? 
                                        <Fragment>
                                            <InputOption label="Enseignant Chercheur en Gestion" />
                                            <InputOption label="Enseignant Chercheur en Economie" />
                                            <InputOption label="Enseignant Chercheur en Informatique" />
                                            <InputOption label="Enseignant Chercheur en Electronique et Télécommunications" />
                                            <InputOption label="Enseignant Chercheur en Géosciences" />
                                        </Fragment> 
                                : null}
                            </>
                            : 
                            <>
                               
                                <InputOption value="Formation TECNA" label="Formation Certifiante en ligne (UFR TECNA)" />
                            </>
                        }
                        </> 
                            : null}
                    </Form.Select>     
                </Form.Group>
                <Form.Group>
                    
                    <Form.Label className='fw-medium'> Situation professionnelle<span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='pays' required value={dataForm.pays} onChange={handleChange}>
                        <option value="">--- Selectionner ---</option>
                        {dataForm.type_poste ? 
                        <>
                            {dataForm.type_poste === 'PER' ?
                            <>
                                <option>Doctorat</option>
                                <option>Thèse unique</option>
                                <option>PHD ou equivalent</option>
                                <option>Doctorat 3eme Cycle</option>
                            </>
                            :
                            <>
                                {/* <option>Master</option> */}
                                <option>Doctorant</option>
                                <option>Professionnel</option>
                                
                            </>
                        }
                        </>
                        : null }
                    </Form.Select>
                </Form.Group>
                        <Form.Group className="" id="">
                            <Form.Label className='fw-medium'>Diplome Obtenu<span style={{color:'red'}}>*</span></Form.Label>
                            <Form.Select name='diplome' required value={dataForm.diplome} onChange={handleChange}>
                            <option key="" value="">--- Selectionner ---</option>
                                {dataForm.type_poste === 'PATS' ? 
                                <>
                                    <option>Doctorat</option>
                                    <option  key="M" >Master</option>
                                    <option  key="I" >Ingenieur</option>
                                    <option>Licence</option>
                                    <option>BTS</option>
                                    <option>DUEL</option>
                                    <option>DEUG</option>
                                    <option>Master 2</option>
                                </> :
                                <>
                                </>
                                 }
                    </Form.Select>
                    <Input className="mt-2" type='text' label="Année Obtention Diplome" placeholder='Ex 2025' name='publication10' value={dataForm.publication10 || ''} onChange={handleChange} />
                </Form.Group>
                {dataForm.type_poste === "PATS" ? 
                <>
                    <Form.Group id=''>
                    <Form.Label className='fw-medium'>Secteur d'activité <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Control type='text'placeholder='Ex Sante ...' name='annee_experience' required value={dataForm.annee_experience || ''} onChange={handleChange} />
                   
                </Form.Group>
                </> : null} 
                    
                </div>
                )}
                {/* step 3 */}
                {step === 3 && (
                <div className='mb-3'>
                    <InputF required={true} className="rounded-left mb-2" label="lettre de motivation" message={<span style={{color:'red'}}>*</span>} type='file' name='resume_these' onChange={(e) => handleFileChange(e,"resume_these")} />
                    {!selectedFiles["resume_these"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}  
                <InputF required={true} id="copie_carte" className="rounded-left mb-2" label="Dernier diplôme obtenu" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_carte_id' onChange={(e) => handleFileChange(e,"copie_carte_id")} />
                    {!selectedFiles["copie_carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="CV" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
                    {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={false} className="rounded-left mb-2" label="Dernière attestation de travail" message={<span style={{color:'red'}}>*</span>} type='file' name='demande' onChange={(e) => handleFileChange(e,"demande")} />
                    {!selectedFiles["demande"] ? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    {dataForm.type_poste === 'PER' ? 
                    <>
                        <InputF   className="rounded-left mb-2" label="Lettre de recommendation 1"  type='file' name='recommandation1' onChange={(e) => handleFileChange(e,"recommandation1")} />
                        {!selectedFiles["recommandation1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                        <InputF  className="rounded-left mb-2" label="Lettre de recommendation 2"  type='file' name='recommandation2' onChange={(e) => handleFileChange(e,"recommandation2")} />
                        {!selectedFiles["recommandation2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                            <InputF  required={true}  className="rounded-left mb-2" label="Résumé de la Thèse ou du Master" type='file' message={<span style={{color:'red'}}>*</span>} name='resume_these' onChange={(e) => handleFileChange(e,"resume_these")} />
                        {!selectedFiles["resume_these"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                        <InputF className="rounded-left mb-2" label="Publications scientifiques"  type='file' name='publication_scientifique' onChange={(e) => handleFileChange(e,"publication_scientifique")} />
                        {!selectedFiles["publication_scientifique"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                        {/* Gestion d'ajout de nouveau champs */}
                        <div className='autres_publications' >
                        {gestionfichier["publication_scientifique"] ?  
                                <>
                                {!InputVisible.publication2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication2' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication2' onChange={(e) => handleFileChange(e,"publication2")} />
                                        {!selectedFiles["publication2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {/* Fin de Gestion d'ajout de nouveau champs */}
                        {gestionfichier["publication2"] ?  
                                <>
                                {!InputVisible.publication3    ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication3' onChange={(e) => handleFileChange(e,"publication3")} />
                                        {!selectedFiles["publication3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {gestionfichier["publication3"] ?  
                                <>
                                {!InputVisible.publication4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication4' onChange={(e) => handleFileChange(e,"publication4")} />
                                        {!selectedFiles["publication4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {gestionfichier["publication4"] ?  
                            <>
                            {!InputVisible.publication5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication5' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication5' onChange={(e) => handleFileChange(e,"publication5")} />
                                    {!selectedFiles["publication5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication5"] ?  
                            <>
                            {!InputVisible.publication6   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication6' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication6' onChange={(e) => handleFileChange(e,"publication6")} />
                                    {!selectedFiles["publication6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication6"] ?  
                            <>
                            {!InputVisible.publication7   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication7' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication7' onChange={(e) => handleFileChange(e,"publication7")} />
                                    {!selectedFiles["publication7"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication7"] ?  
                            <>
                            {!InputVisible.publication8   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication8' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication8' onChange={(e) => handleFileChange(e,"publication8")} />
                                    {!selectedFiles["publication8"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication8"] ?  
                            <>
                            {!InputVisible.publication9   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication9' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication9' onChange={(e) => handleFileChange(e,"publication9")} />
                                    {!selectedFiles["publication9"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                       
                        </div>
                        <InputF  className="rounded-left mb-2" label="Communications"  type='file' name='communication' onChange={(e) => handleFileChange(e,"communication")} />
                        {!selectedFiles["communication"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                            {gestionfichier["communication"]?  
                                <>
                                {!InputVisible.communication2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication2' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication2' onChange={(e) => handleFileChange(e,"communication2")} />
                                        {!selectedFiles["communication2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication2"] ?  
                                <>
                                {!InputVisible.communication3   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication3' onChange={(e) => handleFileChange(e,"communication3")} />
                                        {!selectedFiles["communication3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication3"] ?  
                                <>
                                {!InputVisible.communication4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication4' onChange={(e) => handleFileChange(e,"communication4")} />
                                        {!selectedFiles["communication4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication4"] ?  
                                <>
                                {!InputVisible.communication5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication5' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication5' onChange={(e) => handleFileChange(e,"communication5")} />
                                        {!selectedFiles["communication5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    </>: null }
                    {/* <InputF className="rounded-left mb-2" label="Autres éléments de preuve pouvant justifier le CV" type='file' name='justificatif1' onChange={(e) => handleFileChange(e,"justificatif1")} />   */}
                    {!selectedFiles["justificatif1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    
                    {complete}
                </div>
                )}
           </div>
           {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuiler remplir tous les champs
                            </div></> : null}
           <div className="buttons">
            {step > 1 && (
                <Button variant='primary' className='float-start mb-2' size="md" onClick={handlePreviousStep}>Précedent</Button>
            )}
            {step < 3 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
            {step === 3 && 
                <Button  variant="primary" type='submit' size="md"
                // disabled={!ok}
                    className="p-2 float-end mb-2">
                    Valider  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            }
            </div>
          </Form>
                </div>
                </div>
            </div>
                        </>
                )}
        </>
    )
}
export default Depot